document.addEventListener('DOMContentLoaded', function () {
    const calculatorBlock = document.querySelector(
        '.org-travel-time-calculator-block'
    );
    const travelTimeBlock = document.querySelector('.travel-time-block');
    const calculatorContent = document.querySelector(
        '.org-travel-time-calculator-block .calculator-content'
    );
    const form = calculatorBlock?.querySelector('form') || calculatorBlock;
    const postalCodeInput = calculatorBlock?.querySelector(
        'input[type="search"]'
    );
    const transportRadios = calculatorBlock?.querySelectorAll(
        'input[type="radio"]'
    );
    const submitButton = calculatorBlock?.querySelector(
        'button[type="submit"]'
    );

    let resultContainer = calculatorContent?.querySelector(
        '.travel-time-result'
    );
    if (!resultContainer && calculatorContent) {
        resultContainer = document.createElement('div');
        resultContainer.className = 'travel-time-result hidden font-display';
        calculatorContent.appendChild(resultContainer);
    }

    if (submitButton) {
        submitButton.addEventListener('click', handleSubmit);
    } else if (form) {
        form.addEventListener('submit', handleSubmit);
    }

    async function handleSubmit(e) {
        e?.preventDefault();

        const selectedTransport = Array.from(transportRadios || []).find(
            (radio) => radio.checked
        )?.value;
        const postalCode = postalCodeInput?.value.trim();

        const postalCodeRegex = /^[1-9][0-9]{3}\s?[A-Z]{2}$/i;

        if (!postalCode) {
            showError('Vul een postcode in');
            postalCodeInput?.focus();
            return;
        }

        if (!postalCodeRegex.test(postalCode)) {
            showError(
                'Vul een geldige Nederlandse postcode in (bijv. 1234 AB)'
            );
            postalCodeInput?.focus();
            return;
        }

        if (!selectedTransport) {
            showError('Selecteer een vervoersmiddel');
            return;
        }

        try {
            const postalCodeClean = postalCode.replace(/\s/g, '');

            const vacancyPostcode = calculatorBlock?.dataset.vacancyPostcode;
            const vacancyPostcodeClean = vacancyPostcode.replace(/\s/g, '');

            const apiUrl = `/umbraco/surface/TravelTimeSurface/GetTravelTime?postalCode=${encodeURIComponent(
                postalCodeClean
            )}&travelMethod=${encodeURIComponent(
                selectedTransport
            )}&location=${encodeURIComponent(vacancyPostcodeClean)}`;

            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
            });

            if (!response.ok) {
                if (response.status === 404) {
                    throw new Error('Reistijd calculator niet beschikbaar');
                } else if (response.status === 400) {
                    throw new Error('Ongeldige invoer');
                } else {
                    throw new Error(
                        `Gebruik een bestaande postcode`
                    );
                }
            }
            
            // Only hide travel time block after successful response
            travelTimeBlock?.classList.add('!hidden');

            const responseText = await response.text();

            let data;
            try {
                const parsedResponse = JSON.parse(responseText);
                data =
                    typeof parsedResponse === 'string'
                        ? JSON.parse(parsedResponse)
                        : parsedResponse;
            } catch (parseError) {
                throw new Error('Ongeldige JSON response ontvangen');
            }

            if (
                !data ||
                typeof data.distance === 'undefined' ||
                typeof data.duration === 'undefined'
            ) {
                throw new Error('Ongeldige data ontvangen');
            }

            showResult(data, selectedTransport);
        } catch (error) {
            console.error('Fout bij ophalen reistijd:', error);
            showError(error.message || 'Er is een fout opgetreden');
        }
    }

    function showResult(data, selectedTransport) {
        if (!resultContainer) return;

        const distance = data.distance
            ? `${data.distance.toFixed(1)} km`
            : 'Onbekend';
        const duration = data.duration
            ? `${Math.round(data.duration)} minuten`
            : 'Onbekend';

        const transportMethods = {
            transit: 'met het openbaar vervoer',
            train: 'met de trein',
            bicycle: 'met de fiets',
            walking: 'te voet',
        };

        const transportText =
            transportMethods[selectedTransport] || 'met de auto';

        resultContainer.innerHTML = `
            <div>
                <div class="mb-6">
                    <h1 class="text-h2 text-white mb-2">Je reisafstand is <span class="font-bold">${distance}</span>, je bent <span class="font-bold">${duration}</span> onderweg</h1>
                    <p class="text-md text-white">wanneer je <span class="font-bold">${transportText}</span> reist.</p>
                </div>
                <a class="atm-link !text-white mt-6" href="#">Terug</a>
                ${
                    data.route
                        ? `<div class="mt-4 text-sm text-white"><strong>Route:</strong> ${data.route}</div>`
                        : ''
                }
            </div>
        `;
        resultContainer.classList.remove('hidden', 'bg-red-50', 'text-red-700');

        const backLink = resultContainer.querySelector('a[href="#"]');
        if (backLink) {
            backLink.addEventListener('click', (e) => {
                e.preventDefault();
                travelTimeBlock?.classList.remove('!hidden');
                resultContainer.classList.add('hidden');
            });
        }
    }

    function showError(message) {
        if (!resultContainer) return;

        resultContainer.innerHTML = `
                <label class="text-white">${message}</label>
        `;
        resultContainer.classList.remove('hidden');
    }
});
